import { call, put, takeEvery } from "redux-saga/effects";
import CafeteriaService from "../../../services/admin/cafeteria";
import { cafeteriaMasterList } from "../../actionCreators/admin/cafeteria";
import { GET_CAFETERIA_MASTER_WATCHER, SAVE_CAFETERIA_WATCHER, DELETE_CAFETERIA_WATCHER } from "../../actionTypes/admin";
import { updateFalseLoader, updateOpenLoader } from "../../actionCreators/spinner";
import { updateAlert } from "../../actionCreators/alert";
import { errorMessage } from "../../../utils/errorMessage";


function* getCafeteriaEffect(action) {
  try {
    yield put(updateOpenLoader());
    let { data } = yield call(CafeteriaService.getAll, action.payload);

    yield put(cafeteriaMasterList(data.recordset));
    yield put(updateFalseLoader());
  } catch (e) {
    yield put(updateFalseLoader());
    yield put(updateAlert(errorMessage(e, 'Something Went Wrong'), 'error'));
  }
}

function* saveCafeteriaEffect(action) {
  try {
    yield put(updateOpenLoader());
    let { data } = yield call(CafeteriaService.save, action.payload);

    if (action.setOpen) action.setOpen(false)
    yield put(cafeteriaMasterList(data.recordset));
    yield put(updateFalseLoader());
    yield put(updateAlert(action.payload.ACTION === 'UPDATE' ? 'Updated Successfully' : 'Created Successfully', 'success'));
  } catch (e) {
    yield put(updateFalseLoader());
    yield put(updateAlert(e.response?.data?.message || 'Something Went Wrong', 'error'));
  }
}

function* deleteCafeteriaEffect(action) {
  try {
    yield put(updateOpenLoader());
    let { data } = yield call(CafeteriaService.delete, action.id);

    yield put(cafeteriaMasterList(data.recordset));
    yield put(updateFalseLoader());
    yield put(updateAlert('Deleted Successfully', 'success'));
  } catch (e) {
    yield put(updateFalseLoader());
    yield put(updateAlert(errorMessage(e, 'Something Went Wrong'), 'error'));
  }
}

//saga
export const CafeteriaSaga = [
  takeEvery(GET_CAFETERIA_MASTER_WATCHER, getCafeteriaEffect),
  takeEvery(SAVE_CAFETERIA_WATCHER, saveCafeteriaEffect),
  takeEvery(DELETE_CAFETERIA_WATCHER, deleteCafeteriaEffect)
]
